module.exports = __webpack_public_path__ + "img/entrance_plant_4@3x.844ee995.jpg";